import { ACTIONS } from ".";
import snackBarUpdate from "../../../actions/snackBarActions";
import Prefix from "../../../config/ApiPrefix";
import AXIOS from "../../../config/Axios";
import SecureStorage from "../../../config/SecureStorage";

export const handleError = (dispatch: any, err: any) => {
  let title = "";
  if (err.response) {
    title = err.response.data.error;
    if (err.response.data.message) {
      title = String(err.response.data?.message).replace(/"|{|}|[|]/g, "");
    }
  } else {
    title = "Something went wrong!";
  }
  snackBarUpdate({
    payload: {
      message: title || "Something went wrong",
      status: true,
      type: "error",
    },
  })(dispatch);
  dispatch({ type: ACTIONS.SET_LOADING, payload: false });
  throw err;
};

export const getAuthHeader = () => {
  const token = SecureStorage.getItem("token");
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

export const changePassword = (body: any) => async (dispatch: Function) => {
  try {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    await AXIOS.post(
      `${Prefix.api}/auth/password_reset/reset_password/`,
      body,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CHANGE_PASSWORD, payload: null });
    snackBarUpdate({
      payload: {
        message: "Password Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
    dispatch({ type: ACTIONS.SET_LOADING, payload: false });
  } catch (err: any) {
    let title = "";
    if (err.response) {
      title = String(err.response.data?.errors?.error);
    } else {
      title = "Something went wrong!";
    }
    snackBarUpdate({
      payload: {
        message: title || "Something went wrong",
        status: true,
        type: "error",
      },
    })(dispatch);
    dispatch({ type: ACTIONS.SET_LOADING, payload: false });
    throw err;
  }
};
export const getUserDetails = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(`${Prefix.sso}/auth/shortprofile/`, {
      headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
    });
    dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: data });
  } catch (err: any) {
    dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: [] });
    handleError(dispatch, err);
  }
};

export const getCities =
  (url: string, newUrl: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api}/core/cities/${url ? `?q=${url}` : newUrl ? newUrl : ""}`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_CITIES, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };

export const getDisplayCities =
  (url: string, newUrl: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(`${Prefix.api}/core/displaycities/`, {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      });
      dispatch({ type: ACTIONS.GET_DISPLAY_CITIES, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };

export const getAreaName = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api}/core/city-area/${url ? `?id=${url}` : ""}`,
      getAuthHeader()
    );
    dispatch({ type: ACTIONS.GET_AREA, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const createProjectSamples =
  (bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/ `,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.CREATE_PROJECT_SAMPLES, payload: data });
      snackBarUpdate({
        payload: {
          message: "Project Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getProjectSample = (id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/project-samples/name?subProject=${id} `,

      getAuthHeader()
    );
    dispatch({ type: ACTIONS.GET_PROJECTS_SAMPLE, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getProjects = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/projects/${url ? `${url}` : ""} `,

      getAuthHeader()
    );
    dispatch({ type: ACTIONS.GET_PROJECTS, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const resetProject = () => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.RESET_PROJECT });
};
export const updateSampleData =
  (bookingData: any, id: any, url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/name`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_SAMPLE_DATA, payload: data });
      snackBarUpdate({
        payload: {
          message: "Samples Details Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getApplications = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/applications/list${url ? `&${url}` : ""} `,

      getAuthHeader()
    );
    dispatch({ type: ACTIONS.GET_APPLICATIONS, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getProjectsFilter = (id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/projects/${id}/`,

      getAuthHeader()
    );
    dispatch({ type: ACTIONS.GET_PROJECTS_FILTER, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getProjectSampleAllData =
  (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/project-samples/${id ? id : ""}`,

        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_PROJECTS_SAMPLE_ALL_DATA, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const createSamplesStorage =
  (id: any, bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/${id}/store`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.CREATE_SAMPLES_STORAGE, payload: data });
      snackBarUpdate({
        payload: {
          message: "Storage Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const updateSamplesStorage =
  (id: any, bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/${id}/store`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_SAMPLES_STORAGE, payload: data });
      snackBarUpdate({
        payload: {
          message: "Storage Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getProjectSampleList = (id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/project-samples/name`,

      getAuthHeader()
    );
    dispatch({ type: ACTIONS.GET_PROJECTS_SAMPLE_LIST, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const createSamplesQc =
  (id: any, bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/${id}/qc`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.CREATE_SAMPLES_QC, payload: data });
      snackBarUpdate({
        payload: {
          message: "Sample Qc Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const updateSamplesQc =
  (id: any, bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/${id}/qc`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_SAMPLES_QC, payload: data });
      snackBarUpdate({
        payload: {
          message: "Sample Qc Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const uploadMediaFiles =
  (bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(`${Prefix.api1}/media/`, bookingData, {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      });
      dispatch({ type: ACTIONS.UPLOAD_MEDIA_FILES, payload: data });
      snackBarUpdate({
        payload: {
          message: "Upload Sucessfully",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getUploadMedia =
  (url: string, newUrl: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(`${Prefix.api1}/media/`, {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      });
      dispatch({ type: ACTIONS.GET_UPLOAD_MEDIA, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getSampleProjectData =
  (url: string, newUrl: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/project-samples/${url}`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_SAMPLE_PROJECT_DATA, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const createLibrary =
  (id: any, bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/${id}/library`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.CREATE_LIBRARY, payload: data });
      snackBarUpdate({
        payload: {
          message: "Storage Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const updateLibrary =
  (id: any, bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/${id}/library`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_LIBRARY, payload: data });
      snackBarUpdate({
        payload: {
          message: "Storage Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getBookingOverview =
  (url: string, newUrl: any) => async (dispatch: Function, id: any) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/stats/${url ? `?${url}` : ""}`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_BOOKING_OVERVIEW, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const createRunPlan =
  (bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/runplans`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.CREATE_RUN_PLAN, payload: data });
      snackBarUpdate({
        payload: {
          message: "runPlan Checking",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getRunPlan =
  (url: string, newUrl: any) => async (dispatch: Function, id: any) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/runplans`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_RUN_PLAN, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getConfigData =
  (url: string, newUrl: any) => async (dispatch: Function, id: any) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/config`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_CONFIG_DATA, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const createSequencing =
  (bookingData: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/runs`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.CREATE_SEQUENCING, payload: data });
      snackBarUpdate({
        payload: {
          message: "Run Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getSequencing =
  (url: string, newUrl: any) => async (dispatch: Function, id: any) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/runs/${url ? `${url}` : ""}`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_SEQUENCING, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const updateSequencing =
  (bookingData: any, id: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.put(
        `${Prefix.api1}/genomics/runs/${id}`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_SEQUENCING, payload: data });
      snackBarUpdate({
        payload: {
          message: "Run Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const updateSequencingQc =
  (bookingData: any, id: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/runs/${id}/qc`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_SEQUENCING_QC, payload: data });
      snackBarUpdate({
        payload: {
          message: "Run Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const postBioInformatics =
  (bookingData: any, id: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/bio-informatics`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.POST_BIOINFORMATICS, payload: data });
      snackBarUpdate({
        payload: {
          message: "BioInformatics Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const UpdateBioInformatics =
  (bookingData: any, id: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.put(
        `${Prefix.api1}/genomics/bio-informatics/${id}`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_BIOINFORMATICS, payload: data });
      snackBarUpdate({
        payload: {
          message: "BioInformatics Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const FetchBioinformatics =
  (url: string, newUrl: any) => async (dispatch: Function, id: any) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/bio-informatics/${url ? `${url}` : ""}`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_BIO_INFORMATICS, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const PostFinalReport =
  (bookingData: any, id: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/deliverables`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.POST_DELIVERABLE, payload: data });
      snackBarUpdate({
        payload: {
          message: "Deliverable Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const UpdateFinalReport =
  (bookingData: any, id: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.put(
        `${Prefix.api1}/genomics/deliverables/${id}`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_DELIVERABLE, payload: data });
      snackBarUpdate({
        payload: {
          message: "Deliverable Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const FetchFinalReport =
  (url: string, newUrl: any) => async (dispatch: Function, id: any) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/deliverables/${url ? `${url}` : ""}`,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.FETCH_FINAL_REPORT, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const PostCloseProject =
  (bookingData: any, id: any) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/projects/${id}/billing`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.POST_CLOSE_PROJECT, payload: data });
      snackBarUpdate({
        payload: {
          message: "Deliverable Created",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const UpdateDataFullFill =
  (bookingData: any, id: any, url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/projects/${id}/mark-data-fulfilled`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_DATA_FULLFILL, payload: data });
      snackBarUpdate({
        payload: {
          message: "Project FullFill Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const UploadStorage =
  (bookingData: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/upload/storage`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPLOAD_STORAGE, payload: data });
      snackBarUpdate({
        payload: {
          message: "Storage Csv File Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const updateProject = (bookingData: any, id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/projects/${id}/`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPDATE_PROJECT, payload: data });
    snackBarUpdate({
      payload: {
        message: "Project Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const uploadReport = (bookingData: any, id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/projects/${id}/upload_report`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPLOAD_REPORT, payload: data });
    snackBarUpdate({
      payload: {
        message: "Report Uploded Successfully",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const UploadSampleQc =
  (bookingData: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/upload/qc`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPLOAD_SAMPLE_QC, payload: data });
      snackBarUpdate({
        payload: {
          message: "Sample Qc Csv File Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };

  export const UploadLibrary =
  (bookingData: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/project-samples/upload/library`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPLOAD_SAMPLE_LIBRARY, payload: data });
      snackBarUpdate({
        payload: {
          message: "Sample Qc Csv File Updated",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };


